import { ref as b, computed as a, onMounted as m, openBlock as l, createBlock as r, normalizeClass as u, withCtx as k, createElementBlock as w, Fragment as p, createTextVNode as L, toDisplayString as j } from "vue";
import x from "../../atoms/anchor-element/anchor-element.vue.js";
import O from "../../atoms/text-icon-element/text-icon-element.vue.js";
const B = /* @__PURE__ */ Object.assign({
  name: "DsLink"
}, {
  __name: "link",
  props: {
    /**
     * trackingData, to be set as data-track attributes for tracking purpose
     */
    trackingData: { type: Object, default: () => ({}) },
    /**
     * Link url, href attribute content
     */
    url: { type: String, required: !0 },
    /**
     * Link openInNewWindow, when is set to true it will open the link in a new window
     */
    openInNewWindow: { type: Boolean, default: !1 },
    /**
     * Link nuxt, when is set to true it will render a nuxt link (vue router link)
     */
    nuxt: { type: Boolean, default: !1 },
    /**
     * Link prefetch, when is set to true it will nuxt will prefetch the page
     */
    prefetch: { type: Boolean, default: !1 },
    /**
     * Link ariaLabel, arial-label attribute content
     */
    ariaLabel: { type: String, default: "" },
    /**
     * Lazy route endpoint
     */
    lazyUrlEndpoint: {
      type: String,
      default: ""
    },
    /**
     * Link text or icon object
     */
    content: {
      type: [String, Object],
      required: !0,
      validator: (n) => n instanceof Object ? ["name", "category", "ariaLabel"].every((t) => t in n) : !0
    },
    /**
     * Link text size (if set to true, it will set heading-xsmall font size)
     */
    heading: {
      type: Boolean,
      default: !1
    },
    /**
     * Link left icon (optional)
     */
    iconLeft: {
      type: [Object, null],
      default: null,
      validator: (n) => ["name", "category"].every((t) => t in n)
    },
    /**
     * Link right icon (optional)
     */
    iconRight: {
      type: [Object, null],
      default: null,
      validator: (n) => ["name", "category"].every((t) => t in n)
    },
    /**
     * Link look (button or link style)
     */
    type: {
      type: String,
      default: "link",
      validator: (n) => ["button", "link"].includes(n)
    },
    /**
     * Link variant (primary, secondary, tertiary, quaternary, quinary)
     */
    variant: {
      type: String,
      default: "primary",
      validator: (n) => ["primary", "secondary", "tertiary", "quaternary", "quinary"].includes(n)
    },
    /**
     * Link color (green, white, black...)
     */
    color: {
      type: String,
      default: "green",
      validator: (n) => ["black", "green", "white", "white-green", "black-green", "grey"].includes(n)
    },
    /**
     * download, adds download attribute
     */
    download: { type: Boolean, default: !1 },
    /**
     * moveIconOnHover, if set to false the icon will not move on hover
     */
    moveIconOnHover: { type: Boolean, default: !0 }
  },
  emits: ["link-clicked"],
  setup(n) {
    const t = n, c = b(null), i = a(() => t.content && t.content instanceof Object), d = a(() => t.content && t.content instanceof Object ? t.content.ariaLabel : t.ariaLabel || t.content), s = a(() => t.type === "button" ? i.value ? `ds-button-icon ds-button-icon--${t.variant} ds-button-icon--${t.color}` : `ds-button ds-button--${t.variant} ds-button--${t.color}` : `ds-button-link ds-button-link--${t.variant} ds-button-link--${t.color}`), f = a(() => t.type === "button" ? t.iconLeft ? t.iconRight ? "ds-button--with-icon-left ds-button--with-icon-right" : "ds-button--with-icon-left" : t.iconRight ? "ds-button--with-icon-right" : "" : ""), h = a(() => t.url || c.value), g = a(() => i.value || t.iconLeft || t.iconRight);
    m(async () => {
      if (!(!t.lazyUrlEndpoint || typeof window > "u"))
        try {
          const o = await (await fetch(t.lazyUrlEndpoint)).json();
          c.value = o == null ? void 0 : o.link;
        } catch (e) {
          console.error(e);
        }
    });
    const y = (e) => e === "right" ? t.iconRight && ["chevron-right-small", "chevron-right", "chevron-left", "chevron-left-small"].includes(t.iconRight.name) : t.iconLeft && ["chevron-right-small", "chevron-right", "chevron-left", "chevron-left-small"].includes(t.iconLeft.name);
    return (e, o) => (l(), r(x, {
      class: u([
        { "ds-button-link--chevron": y("right"), "ds-button-link--static-icon": !n.moveIconOnHover },
        s.value,
        f.value
      ]),
      "tracking-data": { "component-name": e.$options.name, ...n.trackingData },
      url: h.value,
      "open-in-new-window": n.openInNewWindow,
      nuxt: n.nuxt,
      prefetch: n.prefetch,
      "aria-label": d.value,
      download: n.download,
      "data-j-link": "",
      onLinkClicked: o[0] || (o[0] = (v) => e.$emit("link-clicked", v))
    }, {
      default: k(() => [
        g.value ? (l(), r(O, {
          key: 0,
          class: u({ "ds-heading-xsmall": n.heading && n.type === "link" }),
          "icon-left": n.iconLeft ? n.iconLeft : null,
          "icon-right": n.iconRight ? n.iconRight : null,
          text: i.value ? null : n.content,
          icon: i.value ? n.content : null,
          "with-spacing": n.type === "button",
          "data-j-link-text": ""
        }, null, 8, ["class", "icon-left", "icon-right", "text", "icon", "with-spacing"])) : (l(), w(p, { key: 1 }, [
          L(j(n.content), 1)
        ], 64))
      ]),
      _: 1
    }, 8, ["class", "tracking-data", "url", "open-in-new-window", "nuxt", "prefetch", "aria-label", "download"]));
  }
}), D = B;
export {
  D as default
};
